module.exports = __webpack_public_path__ + "img/fifty.69f17abc.png";